"use client"

import React from 'react'
import clsx from 'clsx';

interface DotProps {
    className?: string;
    size?: 'small' | 'medium';
}

const Dot: React.FC<DotProps> = ({ size = 'medium', className }) => {
    return (
        <div className={clsx('dot', className, size)}></div>
    )
}

export default Dot
